// @flow
/*
  A component for choosing time with NO date dependency (see TimePickerWithDate)
*/
import * as React from 'react';
import useDebouncedState from 'utils/useDebouncedState';
import { stringify, isEmpty } from 'utils/functional';
import { withSeconds } from 'utils/date';

import Input from 'components/Input';
import TimeInput from 'components/TimeInput';

const { useState, useEffect } = React;

type Props = {
  value: string,
  onChange: (?string) => void,
  hasError?: boolean
};

const getTimeSupport = () => {
  const input = document.createElement('input');
  input.setAttribute('type', 'time');

  const notValid = 'not-a-time';
  input.setAttribute('value', notValid);

  return input.value !== notValid;
};

const NativeTimeInput = ({
  hasError,
  value,
  datetimeProps,
  onChange
}: {
  hasError: ?boolean,
  value: ?string,
  onChange: (?string) => void,
  datetimeProps: Object
}) => {
  const [currTime, dbTime, setTime] = useDebouncedState(value, 500);

  useEffect(
    () => {
      onChange(isEmpty(dbTime) ? null : withSeconds(stringify(dbTime)));
    },
    [dbTime, onChange]
  );

  return (
    <Input
      type="time"
      hasError={hasError}
      value={currTime || value || ''}
      {...datetimeProps}
      onChange={(e: SyntheticInputEvent<HTMLInputElement>) => {
        setTime(e.currentTarget.value);
      }}
    />
  );
};
const TimePicker = ({ value, onChange, hasError, ...rest }: Props) => {
  const [timeSupported, setTimeSupported] = useState(true);
  useEffect(() => {
    setTimeSupported(getTimeSupport());
  }, []);
  const datetimeProps = {
    ...rest,
    autoComplete: 'off'
  };
  return timeSupported ? (
    <NativeTimeInput
      hasError={hasError}
      value={value}
      datetimeProps={datetimeProps}
      onChange={onChange}
    />
  ) : (
    <TimeInput
      value={isEmpty(value) ? null : value}
      locale={USER_LOCALE}
      onChange={onChange}
      datetimeProps={datetimeProps}
    />
  );
};

export default TimePicker;
